import { Navigate, useLocation } from "react-router";
import type { FCWithChildren } from "../../api-client/resources/types/sharedTypes";
import { isMirageEnabled } from "../../utils/importMeta";
import { useAuthentication } from "../AuthenticationProvider";
import { UserAccessGuard } from "./UserAccessGuard/UserAccessGuard";

const Authenticated: FCWithChildren = ({ children }) => {
	const location = useLocation();
	const { loggedIn } = useAuthentication();

	if (!loggedIn && !isMirageEnabled()) {
		return <Navigate to="/" state={{ from: location }} />;
	}

	return <UserAccessGuard>{children}</UserAccessGuard>;
};

export { Authenticated };
